<adresse-base
        *ngIf="lieuParam.isShowAdresseBaseAndEtablissement"
        [lieuParam]="lieuParam"
        [listeAdresse]="listeAdresse"
        (onAdresseSelect)="selectAdresse($event)"
></adresse-base>


<adresse-filtre
        *ngIf="lieuParam.isShowAdresseFiltre"
        [lieuParam]="lieuParam"
        (onAdresseSelect)="selectAdresse($event)"
></adresse-filtre>